document.addEventListener("DOMContentLoaded",()=>{

const media=document.querySelector(".product-information__media");
const zoom=document.querySelector(".alsidra-hover-zoom");
const zoomLevel = 2.3;
const lensSize = 180;
if(!media||!zoom)return;

const img=media.querySelector(".product-media__image");

if(!img)return;

media.addEventListener("mouseenter",()=>{

zoom.style.backgroundImage=`url(${img.src})`;

});

media.addEventListener("mousemove",(e)=>{

const rect=media.getBoundingClientRect();

const x=((e.clientX-rect.left)/rect.width)*100;
const y=((e.clientY-rect.top)/rect.height)*100;

zoom.style.backgroundPosition=`${x}% ${y}%`;

});

});